{
  "actionCannotBeUndone": "This action cannot be undone.",
  "activeMembers": "Active members",
  "addContact": "Add contact",
  "addInterestAreaInSettings": "No interest areas found. Go to <1>account settings</1> to add new ones.",
  "attachContactToMember": "Attach contact to member",
  "bankrupt": "Bankrupt",
  "bisnode.balance": "Balance",
  "bisnode.result": "Operating result",
  "bisnode.revenue": "Revenue",
  "bisnode.staffCosts": "Staff costs",
  "brreg.addWithoutBrreg": "Add without Brønnøysundsregisterene",
  "brreg.description": "We fetch key information about all companies as of today is registrated in Brønnøysundsregistrene. You can source for the company name, or the organization number if you know it.",
  "brreg.notFindingTheCompany.description": "If you want to register the company without Brønnøysundsregisteret, you can insert the information manually.",
  "brreg.notFindingTheCompany.title": "Not finding the company?",
  "brreg.notFound": "Not found in BRREG.",
  "brreg.searchHelpText": "You can search for the companys name, or their organization number.",
  "brreg.SearchHitOver20": "The search gave more than {{ total }} hits. Show under are {{ length }} first hits. Choose from the list or adjust the search.",
  "brreg.SearchHits": "The search made {{ total }} hits.",
  "brreg.searchLabel": "Search in Brønnøysundsregistrene",
  "brreg.searchPlaceholder": "Company name or organization number",
  "brreg.searhcNoHits": "The search gave 0 hits. Try to search for something else.",
  "brreg.somethingWentWrong": "Something went wrong, try to write a new value.",
  "changeInNumberOfEmployees": "Change in the number of man-years",
  "changeType": "Change type",
  "changeType.error": "Could not change type. Please try again.",
  "collaborators": "Collaborators",
  "invoices": "Invoices",
  "companyInformation": "Company information",
  "companyInformation.update.error": "Could not update company information. Please try again.",
  "companyNotFound": "Could not find company!",
  "companyType": "Company type",
  "companyTypeCode": "Company type code",
  "confirm.deletion": "Confirm that you want to delete these",
  "confirmDelete.associate.question": "Are you sure you want to delete these associates, and all contacts connected to it?",
  "confirmDelete.contact.question": "Are you sure you want to delete these contacts?",
  "confirmDelete.lead.question": "Are you sure you want to delete these leads, and all contacts connected to it?",
  "confirmDelete.member.question": "Are you sure you want to delete these members, and all contacts connected to it?",
  "confirmDeleteMembersQuestion": "Are you sure you want to delete these members, and all the contacts connected to it?",
  "confirmRemoveContactsFromMember": "Are you sure you want to remove these contacts from this company? Count: {{ count }}.",
  "contactChangeCompanyNotification": "Contacts that is already connected to a company, will loose it's connection, and get connected to this company.",
  "contactDetails.inkind.description": "Here is all the inkind registrered on this contact",
  "contactList.description": "Add conacts to the company. If you don't wish to do this now, you can skip it, and add them later.",
  "contacts": "Contacts",
  "contactsRemovedFromMembersStillActive": "The contacts are removed from the members, but are still active.",
  "couldNotRemoveParticipants": "Could not remove participants. Please try again.",
  "createCustomer": "Create customer",
  "dataSavedAutomatically": "The entered data is saved automatically.",
  "delete.associate.error": "Could not delete these associates. Please try again.",
  "delete.associate.modal.title": "Delete these associates from the resource base",
  "delete.contact.error": "Cloud not delete these contacts. Please try again.",
  "delete.contact.modal.title": "Delete these contacts from the resource base",
  "delete.lead.error": "Could not delete these leads. Please try again.",
  "delete.lead.modal.title": "Delete these leads from the resource base",
  "delete.member.error": "Could not delete these members. Please try again.",
  "delete.member.modal.title": "Delete these member from the resource base",
  "deleteValue": "Delete value",
  "editing": "Editing",
  "eventCount": "Event count",
  "excel.downloadTemplate": "Download template",
  "excel.downloadTemplateTips": "To make it easier importing data, we recommend strongly to download our Excel-template",
  "femaleCEO": "Female CEO",
  "femaleChairman": "Female chairman",
  "femaleFounder": "Female founder",
  "updateDataFromBrreg": "Fetch data from Brreg",
  "updateDataFromBrreg.description": "Fetch information from Brønnøysundsregistrene",
  "files": "Files",
  "forcedLiquidation": "Under forced liquidation",
  "gotoContactPage": "Go to contact page",
  "gotoDetailPage": "Go to detail page",
  "import": "Import",
  "import.alreadyInResourceBase": "These already exists in the resource base, and will not be created.",
  "import.amount": "Amount: {{ length }}",
  "import.invalidOrganizationNumber": "Invalid organization numbers",
  "import.invalidOrganizationNumber.description": "Here is a list of which values are invalid, and why, and which row they were found on.",
  "import.member.noneToImport": "No members to import.",
  "import.noneToImport": "None to import",
  "import.template.associates": "Import template for associates",
  "import.template.leads": "Import template for leads",
  "import.template.members": "Import template for members",
  "importAssociates": "Import associates",
  "importContacts": "Import contacts",
  "importLeads": "Import leads",
  "importMembers": "Import members",
  "industry": "Industry",
  "inkindKeptContactDeleted": "will be kept, although the contacts will be deleted.",
  "innovationSupport": "Innovation support",
  "intro": "Intro",
  "invalid.date": "Invalid date",
  "invalidFileType": "Invalid filetype, please select an Excel-sheet like the template.",
  "invalidOrgNumber": "Invalid organization number format.",
  "invoicedDeductible": "Invoiced deductible",
  "invoiceNumber": "Invoice number",
  "keepExistingValue": "Keep existing value",
  "lead": "Lead",
  "leads": "Leads",
  "leads.excelImportError": "Something went wrong when importing from Excel. There might be a difference between your Excel-sheet and the template. Download the template and try again.",
  "leads.Imported": "{{ numberOfLeads }} leads imported!",
  "leads.ImportError": "Something went wrong when creating leads. Please try again.",
  "leads.Importing": "Importing leads...",
  "leads.noneToImport": "No leads to import",
  "liquidation": "Under liquidation",
  "logo": "Logo",
  "logoLimitationExplanation": "Logo files must be either in .jpg or .png format and cannot exceed 1 MB (only one logo for each member).",
  "fileUploadLimitationExplanation": "You can upload the following file formats: .pdf, .doc, .docx, .dot, .xls, .xlsx, with a maximum file size of 10MB per file.",
  "mainContact": "Main contact",
  "markedRowsAlreadyRetired": "Marked rows are already retired",
  "marketValue": "Market value",
  "customer": "Customer",
  "memberFee": "Member fee",
  "memberFeeDescription": "Here is all registrated in kind for the member across projects, activities and events.",
  "memberFeeTitle": "Overview of members in kind",
  "memberInformation": "Memberinformation",
  "memberProfile": "Member profile",
  "memberRetiredDescriptionPart1": "This member is retired, retiredate:",
  "memberRetiredDescriptionPart2": "The member cannot be updated before it is unretired.",
  "customers": "Customers",
  "membersMayHaveConnectedContacts": "These member may have connected contacts.",
  "missing.name": "Name is missing",
  "missing.type": "Type is missing",
  "nace": "NACE code",
  "newContact": "New contact",
  "noContactsInMember": "No contacts connected to this member.",
  "noRowsMarkedRequired": "No rows marked! Aleast one row must be marked to perform this action.",
  "numberOfEmployees": "Number of employees",
  "numberOfEmployeesLastYear": "Number of employees last year",
  "opportunities": "Opportunities",
  "orderNumber": "Order Number",
  "organization": "Organization",
  "organizationNumber.invalidFormat": "Invalid format on organization number",
  "participantsRemoved": "Participants were removed",
  "projectCount": "Project count",
  "readyForImport": "ready for import",
  "registeredTooMuch": "Registered support over limit",
  "registratedHours": "Registrated hours",
  "registration": "Registration",
  "registration.businessEnterprise": "Reg. Business Enterprise",
  "registration.foundation": "Reg. Foundation",
  "registration.legal": "Reg. Legal entity",
  "registration.nonProfit": "Reg. Non-Profit",
  "registration.vat": "Reg. VAT-registry",
  "removeAllContactsFromList": "Remove all contacts from the list",
  "removingParticipants": "Removing participants",
  "replaceExistingValue": "Replace existing value with...",
  "retire.associate.error": "Could not retire these assocaites. Please try again.",
  "retire.associate.modal.title": "Retire these associates from the resource base",
  "retire.contact.error": "Could not retire these contacts. Please try again.",
  "retire.contact.modal.title": "Retire these contacts from the resource base",
  "retire.lead.error": "Could not retire these leads. Please try again.",
  "retire.lead.modal.title": "Retire these leads from the resource base",
  "retire.member.error": "Could not retire these members. Please try again.",
  "retire.member.modal.title": "Retire these member from the resource base",
  "searchForContacts": "Search for contacts",
  "selectCompany": "Select company",
  "sumInnovationSupport": "Total recieved innovation support from the business garden",
  "supportIntensity": "Support intensity",
  "supportMarketValue": "Market value of innovation support services from the business garden",
  "tooMuchSupport": "Support over limit",
  "uniqueParticipants": "Unique participants",
  "uniqueParticipantsOfMembers": "Of a total of {{participantsCount}} divided into {{membersCount}} members",
  "import.invalidEmailsFound": "Invalid emails found. Here is a list of the invalid values, and what rows they were found on.",
  "import.duplicateEmailsFound": "Duplicate emails found. Here is a list of the invalid values, and what rows they were found on.",
  "import.existsInResourceBase": "These exists in the resource base already, and will not be created.",
  "import.invalidOrgNoFound": "Invalid organizationnumber found! Here is a list of the invalid values, and what row they were found on.",
  "import.contact.readyForImport": "{{ contacts }} contact(s) ready for import, and {{ leads }} lead(s) (companies)",
  "import.template.contacts": "Import template for contacts",
  "import.contact.noneToImport": "No contacts to import",
  "showDuplicateEmails": "Show duplicate emails",
  "showInvalidOrgNumbers": "Show invalid organization numbers",
  "showExisting": "Show existing",
  "showInvalidEmails": "Show invalid emails",
  "selectMember": "Select member",
  "memberContacts": "Contacts belonging to this member:",
  "noMemberContacts": "This member has no contacts to recommend courses to",
  "contactsAlreadyRecommended": "These members have already been recommended this course:",
  "companyWithoutCategory": "Company without category",
  "notSetMemberNotification.title": "It exists companies without a category",
  "notSetMemberNotification.description": "These companies should have a category, to calculate inkind correctly. Click on \"Show companies without category\" to set a category for these companies.",
  "notSetMemberNotification.button.show": "Show companies without category",
  "notSetMemberNotification.button.hide": "Hide notification",
  "notSetContactMemberNotification.title": "Error in inkind? Measures are required to calculate it correctly",
  "notSetContactMemberNotification.description": "In order to calculate inkind correctly, all contacts must be associated with a company. You have contacts that lack a connection to a company. Click on 'Show contacts without company' to associate a company with these contacts.",
  "notSetContactMemberNotification.button.text": "Show contacts without company",
  "notSetContactMemberNotification.toast.error.generic": "Could not update inkind for contacts. Please try again.",
  "notSetContactMemberNotification.toast.error.updateContact": "Could not update contact {{ name }}",
  "notSetContactMemberNotification.toast.error.updateInkind": "Could not update inkind for contact {{ name }}",
  "notSetContactMemberNotification.modal.title": "Connect contact to a company",
  "notSetContactMemberNotification.modal.description": "We have suggested possible companies to {{ suggestion }} contacts, but it is still {{ missing }} contacts without a connection.",
  "notSetContactMemberNotification.modal.description.suggestions": "It is {{ count }} of {{ total }} contacts without a company connection.",
  "notSetContactMemberNotification.confirm.title": "Confirmation",
  "notSetContactMemberNotification.confirm.description": "{{ count }} contacts has been updated.",
  "notSetContactMemberNotification.confirm.missing": "{{ count }} contacts is still without a company. Do you want to continue?",
  "notSetContactMemberNotification.confirm.missing.link": "Connect to a company",
  "notSetContactMemberNotification.modal.missingCompany": "Do you not find the company here? Create a new below",
  "notSetContactMemberNotification.table.column.contact": "Contact",
  "notSetContactMemberNotification.table.column.company": "Choose company",
  "notSetContactMemberNotification.table.subtitle.others": "Others",
  "notSetContactMemberNotification.button.submit.text": "Confirm and save",
  "notSetContactMemberNotification.button.cancel.text": "Cancel",
  "contact.created.confirmation.text": "The contact <1>{{ name }}</1> is added to the contactlist."
}
